// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WQ20","importantInfo":"styles_importantInfo__15Nsi"};